'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = reducer;

var _actions = require('./actions');

var FIXED = {
  isLoading: false,
  isReady: false,
  byTournamentId: {
    'tortugas': {
      active: false
    },
    'hurlingham': {
      active: false
    },
    'palermo': {
      active: false
    }
  }
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? FIXED : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var nextState = state;

  switch (action.type) {
    case _actions.GET_FINAL:
      if (action.sequence.type === 'start') {
        nextState = _extends({}, state, {
          isLoading: true
        });
      } else if (action.error) {
        nextState = _extends({}, state, {
          isLoading: false,
          error: true,
          message: action.payload
        });
      } else {
        var _extends2;

        nextState = _extends({}, state, {
          isLoading: false,
          isReady: true,
          byTournamentId: _extends({}, state.byTournamentId, (_extends2 = {}, _extends2[action.meta.tournamentId] = action.payload, _extends2))
        });
      }
      break;
    default:
      break;
  }

  return nextState;
}

module.exports = exports['default'];